import React, { Component } from "react";
import { getSalesStartedForKiosk } from "../lib/dataQueries";

import ActivityDetailField from "../components/activityDetailField";

class ActivityDetailFieldContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startSale: 0,
      finalizeSale: 0,
    };
  }

  async componentWillMount() {
    const { record } = this.props;

    try {
      const stats = await getSalesStartedForKiosk(record.id);
      if (stats) {
        this.setState({
          startSale: stats.salesStarted,
          finalizeSale: stats.salesFinalized,
        });
      } else {
        console.warn("No stats returned");
      }
    } catch (e) {
      console.error("Error getting stats", e);
    }
  }

  render() {
    const { startSale, finalizeSale } = this.state;

    return (
      <ActivityDetailField startSale={startSale} finalizeSale={finalizeSale} />
    );
  }
}

ActivityDetailFieldContainer.defaultProps = { addLabel: true };

export default ActivityDetailFieldContainer;



// WEBPACK FOOTER //
// ./src/containers/activityDetailField.js